import { useState } from 'react';
import { Bell, Mail, Globe, Construction } from 'lucide-react';
import DashboardLayout from '@/components/layout/DashboardLayout';

export default function Settings() {
  return (
    <DashboardLayout>
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
          {/* Header */}
          <div className="border-b border-slate-200 p-6">
            <h1 className="text-2xl font-bold text-slate-900">Configuración</h1>
            <p className="mt-1 text-sm text-slate-500">
              Gestiona las configuraciones de tu cuenta
            </p>
          </div>

          <div className="p-6">
            {/* Mensaje de Construcción */}
            <div className="bg-slate-50 rounded-lg p-8 border border-slate-200 text-center">
              <Construction className="h-12 w-12 text-primary-500 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-slate-900 mb-3">
                Configuraciones en Desarrollo
              </h2>
              <p className="text-slate-600 max-w-2xl mx-auto">
                Estamos trabajando en mejorar tu experiencia. Por el momento, la aplicación está utilizando la configuración predeterminada:
              </p>
              <ul className="mt-4 space-y-2 text-slate-600 text-sm">
                <li>• Idioma: Español</li>
                <li>• Zona Horaria: Detectada automáticamente de tu navegador</li>
                <li>• Notificaciones: Activadas para eventos importantes</li>
              </ul>
              <p className="mt-6 text-sm text-slate-500">
                Pronto podrás personalizar estas configuraciones según tus preferencias.
              </p>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
} 